export default "__VITE_PUBLIC_ASSET__6a640255__"